import Revelar from './Revelar';
import styles from './LandingBase.module.css';

const funcionalidades = [
  {
    icone: 'query_stats',
    titulo: 'Projeção do fim do mês',
    descricao: 'No ritmo atual de gastos, você sabe hoje como o mês vai fechar. Sem surpresa no dia 30.'
  },
  {
    icone: 'credit_card',
    titulo: 'Cartões sem susto',
    descricao: 'Fatura estimada do ciclo, limite e vencimento sempre à vista. Você sabe o tamanho da fatura antes de ela fechar.'
  },
  {
    icone: 'flag',
    titulo: 'Metas com sinal de estouro',
    descricao: 'Metas por categoria, com sugestão de valor pela sua média e sinal vermelho na hora que estourar.'
  },
  {
    icone: 'bolt',
    titulo: 'Lançamento em segundos',
    descricao: 'Registrar um gasto leva segundos, com defaults inteligentes. Nada de fórmula nem planilha abandonada.'
  },
  {
    icone: 'pie_chart',
    titulo: 'Pra onde foi seu dinheiro',
    descricao: 'Gastos por categoria com comparação ao período anterior. Clareza de onde você gasta e onde dá pra segurar.'
  },
  {
    icone: 'account_balance',
    titulo: 'Tudo num lugar',
    descricao: 'Contas, cartões e movimentações reunidos, com insights automáticos do período. Nada de abrir cinco apps.'
  }
];

const Features = () => {
  return (
    <section id="funcionalidades" className={styles.section}>
      <Revelar>
        <div className={styles.sectionHead}>
          <span className={styles.eyebrow}>Funcionalidades</span>
          <h2 className={styles.sectionTitle}>Tudo pra sair do caos financeiro</h2>
          <p className={styles.sectionSub}>Sem planilha, sem complicação. O essencial pra assumir o controle do seu dinheiro.</p>
        </div>
      </Revelar>

      <div className={styles.featuresGrid}>
        {funcionalidades.map((f, i) => (
          <Revelar key={f.titulo} atraso={(i % 3) * 80} className={styles.cardWrap}>
            <div className={styles.card}>
              <span className={styles.cardIcon}>
                <span className="material-symbols-rounded">{f.icone}</span>
              </span>
              <h3 className={styles.cardTitle}>{f.titulo}</h3>
              <p className={styles.cardDesc}>{f.descricao}</p>
            </div>
          </Revelar>
        ))}
      </div>
    </section>
  );
};

export default Features;
